import { createStore, applyMiddleware, combineReducers, compose } from "redux";
// import thunk from 'redux-thunk'
import todoReducer from "./Reducers/todoAddReducer";
import counterReducer from "./Reducers/counterReducer"


const rootReducer = {
  todo: todoReducer,
  counter: counterReducer
};

const reducers = combineReducers(rootReducer);

const store = createStore(reducers);

export default store;
